import { apiFetch } from '@ami/react/core';

const _baseEndPoint = 'quote-documents';

export default class CustomQuoteDocument {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name || '';
      this.quoteId = item.quoteId;
      this.fileUrl = item.fileUrl;
      this.fileKey = item.fileKey;
      this.fileName = item.fileName;
      return;
    }
    this.id = null;
    this.name = '';
    this.quoteId = undefined;
    this.fileUrl = undefined;
    this.fileKey = undefined;
    this.fileName = undefined;
  }

  static create(orderId, item) {
    return apiFetch(`${_baseEndPoint}/${orderId}`, 'POST', item);
  }

  static createShared(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/shared/${id}`, 'POST');
  }

  static delete(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/${id}`, 'DELETE');
  }

  static deleteShared(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/shared/${id}`, 'DELETE');
  }

  static getDownloadUrl(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/${id}`);
  }

  static getDownloadSharedUrl(orderId, id) {
    return apiFetch(`${_baseEndPoint}/${orderId}/shared/${id}`);
  }

  static getDownloadExistingBucketPhotosUrl(quoteId, productId, photoId) {
    return apiFetch(
      `${_baseEndPoint}/${quoteId}/product/${productId}/existing-bucket-photos/${photoId}`
    );
  }
}
